import * as ReactDOM from "react-dom";
import RemoConference from "./App";

const MOUNT_NODE = document.getElementById("root");

const render = () => {
  ReactDOM.render(<RemoConference />, MOUNT_NODE);
};

render();
